import { Box, SxProps, Theme } from "@mui/material";
import dayjs, { Dayjs } from "dayjs";

import { DatePickerComponent } from "../date_picker";

export const DatePeriodPicker = (props: {
  isLoading: boolean;
  sx?: SxProps<Theme>;
  dateColumn: string;
  columns: { name: string; caption: string }[];
  minDate: Dayjs | null;
  maxDate: Dayjs | null;
  startDate: Dayjs;
  setStartDate: (startDate: Date | undefined) => void;
  endDate: Dayjs;
  setEndDate: (endDate: Date | undefined) => void;
}) => {
  const {
    sx,
    dateColumn,
    columns,
    isLoading,
    minDate,
    maxDate,
    startDate,
    setStartDate,
    endDate,
    setEndDate,
  } = props;

  const isIncomplete = isLoading || !columns.find((c) => c.name === dateColumn);

  const noMinMax = !minDate || !maxDate;

  return (
    <Box
      sx={{
        ...sx,
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        justifyContent: "end",
      }}
    >
      <Box sx={{ mr: 3 }}>
        <Box
          sx={{
            fontSize: 11,
            mb: 0.1,
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <Box>From &nbsp;</Box>
          {isIncomplete || noMinMax ? (
            "(inc)"
          ) : (
            <>(inc | min: {dayjs(minDate).utc().format("MM/DD/YYYY")})</>
          )}
        </Box>
        <DatePickerComponent
          isLoading={isLoading}
          sx={{ width: 160 }}
          value={startDate}
          onChange={(value) => {
            if (isIncomplete || !value) {
              return;
            }
            setStartDate(value?.utc().toDate());
          }}
        />
      </Box>

      <Box>
        <Box
          sx={{
            fontSize: 11,
            mb: 0.1,
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <Box>To &nbsp;</Box>
          {isIncomplete || noMinMax ? (
            "(inc)"
          ) : (
            <>(inc | max: {dayjs(maxDate).utc().format("MM/DD/YYYY")})</>
          )}
        </Box>

        <DatePickerComponent
          isLoading={isLoading}
          sx={{ width: 160 }}
          value={endDate}
          onChange={(value) => {
            if (isIncomplete || !value) {
              return;
            }
            setEndDate(value?.utc().toDate());
          }}
        />
      </Box>
    </Box>
  );
};
